import type { MovimentoRecord } from "@/lib/movimento";
import {
  resolveStatoUi,
  rowErrorDetail,
  rowJobAttempts,
  statoUiLabel,
} from "@/lib/movimentoUi";
import { Badge } from "@/components/ui/badge";

export function MovimentoStatoBadge({ movimento }: { movimento: MovimentoRecord }) {
  const stato = resolveStatoUi(movimento);
  const label = statoUiLabel(stato);
  const error = rowErrorDetail(movimento);
  const attempts = rowJobAttempts(movimento);

  let title = label;
  if (stato === "errore" && error) {
    title = `Errore: ${error}`;
  } else if (stato === "in_elaborazione" && attempts !== null) {
    title = `Invio in corso (tentativi: ${attempts})`;
  } else if (stato === "in_elaborazione") {
    title = "Invio a RENTRI in corso o in attesa di esito";
  } else if (stato === "bozza") {
    title = "Movimento non ancora inviato a RENTRI";
  } else if (stato === "inviato") {
    title = "Movimento trasmesso correttamente a RENTRI";
  } else if (stato === "annullato") {
    title = "Movimento annullato";
  }

  const badge = (
    <Badge variant={variantFor(stato)} title={title} className="whitespace-nowrap">
      {stato === "in_elaborazione" && (
        <span
          aria-hidden
          className="mr-1 inline-block h-2 w-2 animate-pulse rounded-full bg-current opacity-70"
        />
      )}
      {label}
    </Badge>
  );
  if (stato !== "errore" || !error) return badge;
  return (
    <div className="flex max-w-[260px] flex-col items-start gap-0.5">
      {badge}
      <span className="line-clamp-2 text-[11px] leading-snug text-destructive" title={error}>
        {error}
      </span>
    </div>
  );
}

function variantFor(
  s: ReturnType<typeof resolveStatoUi>,
): "default" | "secondary" | "outline" | "destructive" | "success" | "warning" {
  switch (s) {
    case "inviato":
      return "success";
    case "in_elaborazione":
      return "warning";
    case "errore":
      return "destructive";
    case "annullato":
      return "secondary";
    case "bozza":
    default:
      return "outline";
  }
}
